import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IExpenseComment } from "../interfaces/Expense/IExpenseComment";

enum ExpenseCommentServiceEnum {
  getByExpenseId = "/"
}

export class ExpenseCommentService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/expense/comment");
  }

  public getByExpenseId = async (expenseId: number): Promise<IExpenseComment[]> => await this.GET(ExpenseCommentServiceEnum.getByExpenseId + expenseId);
}



// WEBPACK FOOTER //
// ./src/services/api/ExpenseComment.service.ts